import React from 'react'
import {Box, Typography} from '@mui/material'
import Card from 'src/components-new/layout/Card'
import EmptyState from 'src/components-new/layout/EmptyState'
import {Caregiver} from 'src/types/types'
import {familyTypes} from 'src/constants/constants'
import {CARD_BORDER_COLOR, CARD_BORDER_RADIUS, NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface FamilyCardSectionProps {
  caregivers: Caregiver[]
}

function InfoRow({label, value}: {label: string; value?: string}): JSX.Element {
  return (
    <Box sx={{display: 'flex', gap: 1, alignItems: 'baseline'}}>
      <Typography variant="caption" sx={{color: NEUTRAL_SCALE[500] ?? 'text.secondary', minWidth: 90, flexShrink: 0}}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{color: value ? 'text.primary' : NEUTRAL_SCALE[300], wordBreak: 'break-word'}}>
        {value || '—'}
      </Typography>
    </Box>
  )
}

export default function FamilyCardSection({caregivers}: FamilyCardSectionProps): JSX.Element {
  return (
    <Card title="Nucleo familiare">
      {caregivers.length === 0 ? (
        <EmptyState title="Nessun risultato" description="Nessun familiare registrato" />
      ) : (
        <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)'}, gap: 2}}>
          {caregivers.map((cg, index) => {
            const fullName = [`${cg.title || ''}`, cg.firstName, cg.lastName].filter(Boolean).join(' ').trim()
            const role = familyTypes[cg.caregiverType as keyof typeof familyTypes] ?? cg.caregiverType
            const phone = cg.cellPhoneNumber || cg.phoneNumber

            return (
              <Box
                key={cg._id ?? index}
                sx={{
                  border: `1px solid ${CARD_BORDER_COLOR}`,
                  borderRadius: CARD_BORDER_RADIUS,
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.75,
                  bgcolor: 'background.paper',
                }}
              >
                <Typography variant="subtitle2" sx={{fontWeight: 600, mb: 0.5}}>
                  {fullName || `Familiare ${index + 1}`}
                </Typography>
                <InfoRow label="Ruolo" value={role} />
                <InfoRow label="Telefono" value={phone} />
                <InfoRow label="Email" value={cg.email} />
              </Box>
            )
          })}
        </Box>
      )}
    </Card>
  )
}
